// Copyright (c) 2017 Deere & Company

import RecordAuditHeader from './record-audit-header';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    city: state.tcsm.recordAudit.auditRecording.city,
    claims: state.tcsm.recordAudit.auditRecording.claims,
    leadAccountName: state.tcsm.recordAudit.auditRecording.leadAccountName,
    state: state.tcsm.recordAudit.auditRecording.state,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RecordAuditHeader);



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit-header/index.js